module.exports = __webpack_public_path__ + "static/media/bullseye.0cfec153.svg";